<ptl-v3-content-card [item]="cardItem()" [reserveRows]="reservedRows()" view="list" (cardClicked)="onCardOpen()"></ptl-v3-content-card>
